<template>
  <!-- The Modal -->
  <div
    id="editModal"
    class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
            title="Edit Design Type"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="name">Name «<span class="text-muted">English</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="English Name"
                        rules="required"
                      >
                        <b-form-input
                          id="name"
                          v-model="updatedDesignType.name"
                          name="name"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="nameAR">Name «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Arabic Name"
                        rules="required"
                      >
                        <b-form-input
                          id="nameAR"
                          v-model="updatedDesignType.nameAR"
                          class="arabic-font"
                          name="nameAR"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                          dir="rtl"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { codeMultiple, codeBasic } from './code'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import designTypesService from '@/services/settings/designTypesService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    ToastificationContent,
  },
  props: ['type'],
  data() {
    return {
      updatedDesignType: {
        id: '',
        name: '',
        nameAR: '',
      },
      emailValue: '',
      createdService: {
        name: '',
        nameAR: '',
        description: '',
        descriptionAR: '',
        image: '',
        serviceParentId: '',
      },
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      edited_service: {
        name: '',
        description: '',
      },
      codeBasic,
    }
  },
  mounted() {
    this.$watch(() => this.type, val => {
      /* Init Updated Object (Which will be sent To API) */
      this.updatedDesignType = {
        id: val.id,
        name: val.name,
        nameAR: val.nameAR,
      }
      this.selected = val.parent?.id ?? null
    })
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            designTypesService.put(this.updatedDesignType)
              .then(response => {
                this.$emit('refresh', 'true')
                $('#editModal').modal('hide')
                if (response && response.status === 200) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: 'Design Type Is Updated Successfully !',
                    },
                  })
                }

                this.loading = false
              })
          }
        })
        .catch(
          function (error) {
            $('#editModal').modal('hide')
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Error',
                icon: 'CheckIcon',
                variant: 'Error',
                text: 'Error !',
              },
            })
            return Promise.reject(error)
          },
        )
    },
    resetDropzone() {
      this.$refs.createServiceRef.removeAllFiles()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
label{
  font-weight: bold;
}
</style>
